// API 基址（开发环境见 .env.development）
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';

/**
 * 视频流基址：开发环境默认直连后端，避免 CRA proxy 转发大文件/Range 流时 ECONNRESET。
 * 生产环境使用 REACT_APP_MEDIA_BASE_URL 或与 API_BASE_URL 相同。
 */
export const MEDIA_BASE_URL = (
    process.env.REACT_APP_MEDIA_BASE_URL ||
    (process.env.NODE_ENV === 'development' ? 'http://localhost:8080' : API_BASE_URL)
).replace(/\/$/, '');

// 用户模块路径（与后端 SysUserController 一致）
export const API_PATHS = {
    USER: {
        REGISTER: '/api/sys_user/register',
        LOGIN: '/api/sys_user/login',
        LIST: '/api/sys_user/list',
        GET_BY_ID: '/api/sys_user/id',
        CREATE: '/api/sys_user/create',
        UPDATE: '/api/sys_user/update',
        DELETE: '/api/sys_user/delete',
        GRANT_ADMIN: '/api/sys_user/grant/admin',
        REVOKE_ADMIN: '/api/sys_user/revoke/admin',
    },
    VIDEO: {
        SCAN: '/api/video/scan',
        SCAN_BROWSE: '/api/video/scan/browse',
        LIST: '/api/video/list',
        GET_BY_ID: '/api/video/id',
        META_UPDATE: '/api/video/meta/update',
        ASSIGN: '/api/video/assign',
        REVOKE: '/api/video/revoke',
        DELETE: '/api/video/delete',
        ACCESS: '/api/video/access',
        PLAY: '/api/video/play',
        CATEGORY_LIST: '/api/video/category/list',
        CATEGORY_CREATE: '/api/video/category/create',
        CATEGORY_UPDATE: '/api/video/category/update',
        CATEGORY_DELETE: '/api/video/category/delete',
        TAG_LIST: '/api/video/tag/list',
        TAG_CREATE: '/api/video/tag/create',
        TAG_UPDATE: '/api/video/tag/update',
        TAG_DELETE: '/api/video/tag/delete',
    },
    IMAGE: {
        SCAN: '/api/image/scan',
        SCAN_BROWSE: '/api/image/scan/browse',
        LIST: '/api/image/list',
        GET_BY_ID: '/api/image/id',
        ASSIGN: '/api/image/assign',
        REVOKE: '/api/image/revoke',
        DELETE: '/api/image/delete',
        ACCESS: '/api/image/access',
        VIEW: '/api/image/view',
    },
    FUND: {
        DETAIL: '/api/fund',
        NAV: '/api/fund',
        HOLDINGS: '/api/fund',
        HOLDINGS_HISTORY: '/api/fund',
        SECTORS: '/api/fund',
        NEWS: '/api/fund',
        WATCHLIST: '/api/fund/watchlist',
        WATCHLIST_ADD: '/api/fund/watchlist/add',
        WATCHLIST_REMOVE: '/api/fund/watchlist/remove',
        COMPARE: '/api/fund/compare',
        AGENT_INBOX: '/api/fund/agent/inbox',
        AGENT_INBOX_READ: '/api/fund/agent/inbox',
    },
    NEWS: {
        CATEGORIES: '/api/news/categories',
        LIST: '/api/news/list',
        DETAIL: '/api/news',
        FEED: '/api/news/feed',
        SUBSCRIPTION: '/api/news/subscription',
        SUBSCRIPTION_REMOVE: '/api/news/subscription/remove',
        ADMIN_IMPORT: '/api/news/admin/import',
    },
    SYSTEM: {
        CONFIG_LIST: '/api/system/config/list',
        CONFIG_DETAIL: '/api/system/config',
        CONFIG_CREATE: '/api/system/config',
        CONFIG_UPDATE: '/api/system/config/update',
        CONFIG_DELETE: '/api/system/config/delete',
        ROLE_LIST: '/api/system/role/list',
        ROLE_PERMISSIONS: '/api/role-permissions/getAllRolePermissions',
    },
};
